/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import Badge from '@material-ui/core/Badge';
import Grid from '@material-ui/core/Grid';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

import { getPatientAuditById } from '../../../actions/areas/planner/queryActions';
import { parseShortDateTime, isValidDateFormat } from '../../../utils/dates';

export default function AuditHistory({ modelDetails, auth, onClose }) {
  const [state, setState] = useState({
    model: null,
    isLoading: true,
  });

  const callback = response => {
    if (response !== null) setState({ ...state, model: response.variances });
  };

  if (state.model === null) getPatientAuditById(auth, modelDetails.id, false, callback);

  const isBoolean = value => typeof value === 'boolean';

  const parseValue = value =>
    // eslint-disable-next-line no-use-before-define
    isBoolean(value) ? value.toString() : isValidDateFormat(value) ? parseShortDateTime(value) : value;

  const headerRender = () => {
    return (
      <div className="sidePanel-header card-status-green">
        <div className="sidePanel-header-subtitle">
          <Box display="flex">
            <Box flexGrow={1} py={1}>
              <Typography variant="subtitle1">Patient Audit Details</Typography>
            </Box>
            <Box>
              <IconButton onClick={() => onClose()}>
                <CancelIcon />
              </IconButton>
            </Box>
          </Box>
        </div>
        <div className="sidePanel-header-wrapper">
          <div className="sidePanel-header-left-info-wrap">
            <div className="sidePanel-header-title">
              <Typography variant="h2" gutterBottom>
                {modelDetails.fullName}
              </Typography>
            </div>
            <div className="sidePanel-header-info patient-header">
              <Box className="assignment-desc-info" display="flex" flexDirection="row">
                <Box display="flex" flexDirection="row">
                  <Box className="header-icon-wrapper">
                    <Badge className="clinician-badge" color="error">
                      <span className="icon-extend icon-medic" />
                      <span className="info-text">{modelDetails.eventName}</span>
                    </Badge>
                  </Box>
                  <Box className="header-icon-wrapper">
                    <AccessTimeIcon />
                    <span className="info-text"> {modelDetails.dateOfChange}</span>
                  </Box>
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const mapData = prop => {
    return (
      <Grid
        item
        container
        xs={12}
        sm={12}
        className="info-wrapper"
        style={{ paddingLeft: '10px' }}
        key={`propertykey_${prop.propertyName}`}
      >
        <Grid item xs={6} sm={6}>
          {prop.propertyName}
        </Grid>
        <Grid item xs={3} sm={3} className="overflow-wrap-item">
          {parseValue(prop.oldValue) || '-'}
        </Grid>
        <Grid item xs={3} sm={3} className="overflow-wrap-item">
          {parseValue(prop.newValue) || '-'}
        </Grid>
      </Grid>
    );
  };

  const detailsRender = () => {
    return (
      <div className="clinician-info-box" style={{ width: '100%' }}>
        <Typography variant="h6" gutterBottom>
          Patient Changes
        </Typography>
        <div className="activities-table-wrapper">
          <div className="activities-table-head">
            <Grid container>
              <Grid item xs={6} sm={6}>
                <p>Property Name</p>
              </Grid>
              <Grid item xs={3} sm={3}>
                <p>Old value</p>
              </Grid>
              <Grid item xs={3} sm={3}>
                <p>New value</p>
              </Grid>
            </Grid>
          </div>
          <div className="content">
            {state.model !== null && (
              <Box>
                <Grid container spacing={0}>
                  {state.model.map(mapData)}
                </Grid>
              </Box>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="side-panel-content-wrapper">
      <SwipeableDrawer anchor="right" open onOpen={() => {}} onClose={onClose}>
        <div className="sidePanel-wrapper" style={{ width: '635px' }}>
          {state.model !== null && (
            <React.Fragment>
              {headerRender()}
              <div className="sidePanel-content">{detailsRender()}</div>
            </React.Fragment>
          )}
        </div>
      </SwipeableDrawer>
    </section>
  );
}
